import React, {Component} from 'react';
import { Switch, Route, Link, Redirect, BrowserRouter as Router } from 'react-router-dom'
import AppointmentService from '../utils/AppointmentService.js';
import "../CSS/Dashboard.css"
import AppointmentBlurb from './AppointmentBlurb.js';
import URLService from '../utils/URLService.js';
import { ClipLoader } from 'react-spinners';


export default class Dashboard extends Component {
  constructor(props){
    super(props)
    this.URLService = new URLService()
    this.Appt = new AppointmentService()
    var url = this.URLService.getUrl()
    this.state = {
      completed_appointments: [],
      requires_payment_appointments: [],
      upcoming_appointments: [],
      ad: null,
      url: url,
      accountBalance: null,
      page: 1,
      pageTotal: 0,
      appointmentsHTML: [],
    }
    this.linkTo = this.linkTo.bind(this)
    this.getActivity = this.getActivity.bind(this)
    this.clearCache = this.clearCache.bind(this)
    this.getActivity()
    //this.handleScroll = this.handleScroll.bind(this)
  }
  componentDidMount(){
    document.getElementById('background').addEventListener('scroll', this.handleScroll);
    this.Appt = new AppointmentService()

      this.Appt.getAds()
      .then(res =>{
        if(res){
          this.setState({
            ad: res.ad
          })
        }
        else {
          //throw new Error('Invalid response to getting ads' + res);
        }
      })
      .catch(err =>{
        //throw new Error('Error getting ads' + err.message);
      })
    this.watchID = navigator.geolocation.watchPosition((position) => {
      localStorage.setItem('lat', position.coords.latitude)
      localStorage.setItem('lng', position.coords.longitude)

    })
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  };
  clearCache() {
    localStorage.removeItem('appointmentAddress')
    localStorage.removeItem('appointmentVehicles')
    localStorage.removeItem('appointmentVehicle')
    localStorage.removeItem('appointmentServices')
    localStorage.removeItem('allUpgradesArray')
    localStorage.removeItem('allUpgradesMap')
    localStorage.removeItem('appointmentUpgrades')
    localStorage.removeItem('promoAmount')
    localStorage.removeItem('apptDateTime')
    localStorage.removeItem('appointmentPackage')
  }
  getActivity() {
    var page = this.state.page
    page = page
    if(page != this.state.pageTotal)
    this.Appt.getActivity(page)
    .then(res =>{
      if(res){
        this.setState({
          completed_appointments: res.appointments,
          page: page+1
        })
        return res
      }
    })
    .catch(err =>{
      throw new Error('Invalid response to getting activity' + err);
    })
  }

  handleScroll = (event) => {
    var element = document.getElementById('background')
    if (element.scrollHeight - element.scrollTop === element.clientHeight) {
      this.getActivity()
    }
  };
  //doesn't work yet
  linkTo() {
    window.href = this.state.ad.url
  }
  render() {
    var url = this.state.url
    //var token_string ="?auth_token=" + localStorage.getItem('id_token')
    var token_string = ""
    var adImage = null
    var addUrl = null
    var appointmentsHTML = []
    if(this.state.ad){
      addUrl = this.state.ad.web_url
    }
    if(this.state.ad && this.state.ad.webImage && this.state.ad.webImage.web_image && this.state.ad.webImage.web_image.url){
      adImage = this.state.ad.webImage.web_image.url
    }
    var days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
    var months = ['January','February','March','April','May','June','July','August','September','October','November','December'];
    var parentThis = this
    if(this.state.completed_appointments){
      this.state.completed_appointments.forEach(function(appt){
        parentThis.state.appointmentsHTML.push(<Link to={`/details/${appt.id}`} key={appt.id}><AppointmentBlurb appointment={appt} onClick={parentThis.showDetails}></AppointmentBlurb></Link>)
      })
    }
    return (
      <div>
        <div className="maxWidth">
          <div className="bannerAd">
          <a href={addUrl}>
            <img className="bannerAdImage" src={adImage}></img>
          </a>
          </div>
          <Link to="/new-appointment" onClick={this.clearCache} className="btn newApptButton">Book Now</Link>
          {/*<a href="/new-subscription" className="btn spiffyCareButton">Subscribe To Spiffy Care</a>*/}
        </div>
        <h3 className="dashboardHeader">My Appointments</h3>
        <div className="maxWidth">
          <ul className="appointmentsList">
              {this.state.appointmentsHTML}
          </ul>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Components/Dashboard.js